import lightFormat from 'date-fns/lightFormat';
import { plural as pluralize } from '@cian/utils';

import { EServiceId } from '../../../../../../../types/reducers/publishTerms';

import { DATE_PATTERN, PACKAGE_NAMES } from './constants';
import { IPackage } from '../../../../../../../reducers/v2/publicationPackages/types';

export const formatPackageOptionLabel = ({ endDate, offersCount: count, serviceId }: IPackage): string => {
  const singleAvailableWord =
    serviceId === EServiceId.top || serviceId === EServiceId.premium ? 'Доступен' : 'Доступна';

  const availableWord = pluralize(count, [singleAvailableWord, 'Доступно', 'Доступно']);

  const { single, plural, pluralSecondForm } = PACKAGE_NAMES[serviceId];
  const packageName = pluralize(count, [single, plural, pluralSecondForm]);

  const formattedEndDate = lightFormat(new Date(endDate), DATE_PATTERN);

  return count > 1
    ? `(${availableWord} ${count} ${packageName} до ${formattedEndDate})`
    : `(${singleAvailableWord} ${single} до ${formattedEndDate})`;
};
